import React, { useEffect } from 'react'
import _ from 'lodash'
import { Link } from 'react-router-dom'
import { History, Location } from 'history'
import { useDispatch, useSelector } from 'react-redux'
import { Table, Button, Divider, notification } from 'antd'

import CopyToClipboard from 'react-copy-to-clipboard'
import { PaymentTemplateActions } from '../../features/paymentTemplate/actions'
import { getPaymentTemplates } from '../../features/paymentTemplate/selectors'
import { PaymentTemplate, PaymentTemplateColumn } from '../../features/paymentTemplate/types'

import { Page } from '../../components/Page'
import { Layout } from '../../components/Page/Layout'
import { Title } from '../../components/Text'

interface PaymentTemplatesContainerProps {
  history: History
  location: Location<{ showInDashboard?: boolean } | undefined>
}

export const PaymentTemplatesContainer: React.FC<PaymentTemplatesContainerProps> = () => {
  const dispatch = useDispatch()
  const paymentTemplates = useSelector(getPaymentTemplates)

  useEffect(() => {
    dispatch(PaymentTemplateActions.fetchPaymentTemplates())
  }, [dispatch])

  const dataSource = _.map(paymentTemplates, (pt: PaymentTemplate) => {
    return {
      id: pt.id,
      key: pt.id,
      columns: pt.columns,
      name: pt.name
    }
  })

  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name'
    },
    {
      title: 'Image',
      dataIndex: 'columns',
      key: 'image',
      render(_text: string, record: PaymentTemplate) {
        return (
          <div>
            {_.map(record.columns, (column: PaymentTemplateColumn) => {
              return (
                <img
                  key={column.id}
                  className="thumb-image"
                  src={`http://site-collaudo.caldetentazioni.com/images/rateplans/${column.photo}`}
                  alt={column.name}
                />
              )
            })}
          </div>
        )
      }
    },
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      // eslint-disable-next-line react/display-name
      render: (text: string) => (
        <div>
          {text}
          <Divider type="vertical" />
          <CopyToClipboard
            text={text}
            onCopy={() => {
              notification.success({
                description: text,
                message: 'ID copiato'
              })
            }}
          >
            <Button type="ghost">COPY</Button>
          </CopyToClipboard>
        </div>
      )
    },
    {
      title: 'Action',
      key: 'action',
      // eslint-disable-next-line
      render: (_text: string, _record: PaymentTemplate) => (
        <span>
          <Button type="primary" onClick={() => _.noop()}>
            Edit
          </Button>
        </span>
      )
    }
  ]

  return (
    <Page>
      <Layout>
        <Title size="XL">Payment Templates</Title>
        <div>
          <Link to="/">
            <Button>Nuovo</Button>
          </Link>
        </div>
        <Table dataSource={dataSource} columns={columns} />
        <div>
          <Link to="/">
            <Button>Nuovo</Button>
          </Link>
        </div>
      </Layout>
    </Page>
  )
}
